import { render, staticRenderFns } from "./CheckOrders.vue?vue&type=template&id=72489d9b&scoped=true&"
import script from "./CheckOrders.vue?vue&type=script&lang=js&"
export * from "./CheckOrders.vue?vue&type=script&lang=js&"
import style0 from "./CheckOrders.vue?vue&type=style&index=0&id=72489d9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72489d9b",
  null
  
)

export default component.exports